import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import { IconButton } from '@totalsoft/rocket-ui';

const StateTransitionComponent = ({ item, handleClick, openDocumentImage }) => {
  const { t } = useTranslation();

  return (
    <TableRow key={item.stateTransitionId}>
      <TableCell>{item.documentStateName}</TableCell>
      <TableCell>{item.comment && <div onClick={handleClick(item.comment)}>{item.comment}</div>}</TableCell>
      <TableCell>{item.reason && <div onClick={handleClick(item.reason)}>{item.reason}</div>}</TableCell>
      <TableCell>{t('LONG_DATE', { date: item.transitionMoment })}</TableCell>
      <TableCell>{item.userName}</TableCell>
      <TableCell>
        {item.imageId && (
          <span>
            <IconButton tooltip={t('Document.StateTransition.ViewVersion')} onClick={openDocumentImage(item)}>
              <DescriptionIcon />
            </IconButton>
          </span>
        )}
      </TableCell>
    </TableRow>
  );
};

StateTransitionComponent.propTypes = {
  item: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired,
  openDocumentImage: PropTypes.func.isRequired
};

export default StateTransitionComponent;
